module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0115.jpg?v=6075adba";